<template>
<div class="main-container">
  <transition name="slide">
    <div class="position-absolute w-100">
      <Navbar :user="user" v-if="user && user.role" />
      <b-container>
        <router-view></router-view>
      </b-container>
    </div>
  </transition>
</div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';

export default {
  data: () => ({
    user: null,
  }),
  components: {
    Navbar,
    // Footer,
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem('user'));
  },
};
</script>

<style>
@media screen {
  .product-list, .product-list * {
    visibility: hidden;
  }
}
@media print {
  /* Hide everything */
  body * {
    visibility: hidden;
  }

  /* Then display only the product list and its children */
  .product-list, .product-list * {
    visibility: visible;
  }

  /* Adjust the position to be printable */
  .product-list {
    position: absolute;
    left: 0;
    top: 0;
  }
}

html, body {
  position: relative;
  background-color: #222222;
}

.main-container {
  background-color: #222222;
  color: aliceblue;
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}
</style>
